import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { AddEfsaSampnt } from '../types/types'
import { throwOnError } from '../utils/throwOnError'

export const useGetSampntTypes = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    enabled: isEnabled,
    queryKey: ['sampntTypes'],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/efsa/sampnt')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateSampntMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (sampnt: AddEfsaSampnt) => {
      const { data, error } = await authFetch().POST('/efsa/sampnt', {
        body: sampnt
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['sampntTypes']
      })
    }
  })
}

export const useDeleteSampntMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (sampntId: number) =>
      await authFetch().DELETE('/efsa/sampnt/{sampntId}', {
        params: {
          path: { sampntId }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['sampntTypes']
      })
    }
  })
}
